export default __webpack_public_path__ + "static/media/Herken de EDO principes.9736a354.docx";